<template>
  <div>
    <v-toolbar dense>
      <v-text-field
        v-model="searchString"
        class="mb-2"
        hide-details
        prepend-inner-icon="search"
        single-line
        clearable
      />
    </v-toolbar>
    <div class="BranchesItemsWrapper">
      <v-layout class="keywordsList">
        <v-list
          class="pt-0 pb-0"
          style="width: 100%"
        >
          <template v-for="(item, index) in filteredBranches">
            <v-list-tile
              :key="index"
              class="listItem"
              :class="{ isSelectedItem: item == selectedItem }"
              @click="selectedItem = item"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.code }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider
              :key="'div-' + index"
              class="m-0"
            />
          </template>
        </v-list>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    allBranches: {
      type: Array,
      default: () => [],
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      searchString: "",
      filteredBranches: [],
      selectedItem: null,
    };
  },
  watch: {
    searchString(newValue) {
      if (newValue == null) {
        newValue = "";
      }

      this.filteredBranches = this.allBranches.filter((item) => {
        return item.code.toLowerCase().indexOf(newValue.toLowerCase()) != -1;
      });
    },
    selectedItem() {
      this.$emit("selectedItemChanged", this.selectedItem);
    },
  },
  created() {
    this.filteredBranches = this.allBranches;
    if (this.selectedItemId) {
      var selected = this.filteredBranches.filter((item) => {
        return item.customBranchId == this.selectedItemId;
      });

      if (selected.length == 1) {
        this.selectedItem = selected[0];
      }
    }
  },
};
</script>

<style scoped>
.BranchesItemsWrapper {
  height: 500px;
  overflow: auto;
  border: 1px solid rgb(255, 237, 237);
}
.listItem:hover {
  background-color: rgba(0, 0, 0, 0.04);
  text-decoration: underline;
  cursor: pointer;
}
.isSelectedItem {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
